import { parseAttribute } from 'services/Orb/Service'

const ActivityCategoryParser = ({ id, title, enabled }) => ({ id, title, enabled })

export const parseActivityCategoryList = list => list.map(parseAttribute(ActivityCategoryParser))

export const filterActivityCategoryList = list => list.filter(({ enabled }) => enabled)
